/* unplugin-vue-components disabled */import { render } from "./input-files.vue?vue&type=template&id=a952820e&scoped=true"
import script from "./input-files.vue?vue&type=script&lang=js"
export * from "./input-files.vue?vue&type=script&lang=js"

import "./input-files.vue?vue&type=style&index=0&id=a952820e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a952820e"],['__file',"src/components/chat-input-v2/input-files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a952820e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a952820e', __exports__)) {
    api.reload('a952820e', __exports__)
  }
  
  module.hot.accept("./input-files.vue?vue&type=template&id=a952820e&scoped=true", () => {
    api.rerender('a952820e', render)
  })

}


export default __exports__